import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";

import {gsap} from "gsap";
import {BasicSymbol, SymbolStates} from "../reels/symbols/BasicSymbol";
import {XwaysHoarder2} from "../XwaysHoarder2";


/**
 * Created by jonas on 2021-02-19.
 */

export class SymbolUtils {


    public static getAllSymbolsWithState(state:SymbolStates):SimpleReelModelSymbolData[] {
        const coords = XwaysHoarder2.model.winData.matrix.getAllCoordinatesForValue(state);
        const symbols: SimpleReelModelSymbolData [] = [];
        for(let coordinate of coords) {
            symbols.push(XwaysHoarder2.reelView.reels[coordinate.column].model.getVisibleSymbolAt(coordinate.row));
        }
        return symbols;
    }

    public static getAllSymbolsWithStateByReel(state:SymbolStates):SimpleReelModelSymbolData[][] {
        // TODO: TMP!
        if(!XwaysHoarder2.model.winData.matrix){
            return [[], [], [], [], [], []];
        }

        const coords = XwaysHoarder2.model.winData.matrix.getAllCoordinatesForValue(state);
        const reel:SimpleReelModelSymbolData[][] = [[], [], [], [], [], []];


        for(let coordinate of coords) {
            reel[coordinate.column].push(XwaysHoarder2.reelView.reels[coordinate.column].model.getVisibleSymbolAt(coordinate.row));
        }
        return reel;
    }

    public static makeVisibleReelsMatrix(matrix:string[][], removePaddingBefore:number = 0, removePaddingAfter:number = 0):string[][] {
        const result:string[][] = [];
        for(let reel of matrix) {
            if(removePaddingAfter > 0) {
                result.push(reel.slice(removePaddingBefore, -removePaddingAfter));
            }
            else {
                result.push(reel.slice(removePaddingBefore));
            }
        }
        return result;
    }

    public static getSymbolStateAnimations(symbols:SimpleReelModelSymbolData[], state:SymbolStates):gsap.core.Timeline[] {
        const result:gsap.core.Timeline[] = [];
        for(let sym of symbols) {
            result.push((<BasicSymbol>sym.positionable).getStateAnimation(state));
        }
        return result;
    }




}